/**
 * Giá trị combobox đọc số tiền cột form tham số in chứng từ C02-HD lương
 * NHANH3 22.11.2022
 */
export default {
  // Trích vào CP - BHXH
  BHXHCQ: 'BHXH_CQ',
  // Trích vào CP - BHYT
  BHYTCQ: 'BHYT_CQ',
  // Trích vào CP - BHTN
  BHTNCQ: 'BHTN_CQ',
  // Trích vào CP - KPCD
  KPCDCQ: 'KPCD_CQ',
  // Trừ vào lương - BHXH
  BHXH: 'BHXH',
  // Trừ vào lương - BHYT
  BHYT: 'BHYT',
  // Trừ vào lương - BHTN
  BHTN: 'BHTN',
  // Trừ vào lương - KPCD
  KPCD: 'KPCD',
  // Số thực lĩnh
  REALVALUE: 'REALVALUE',
  // Không chọn
  NONE: 'NONE',
};
